import groupBy from "lodash-es/groupBy";

export const STATUS = {SEEN: "seen", ARCHIVED: "archived", NEW: "new"};

export const shouldBadgeModule = (notification = {}) => {
  const {priority} = notification;

  return priority === "high";
};

export const badgePriority = (notifications = []) => {
  const grouped = groupBy(notifications, "priority");

  for (let p of priorities) {
    if (grouped[p] && grouped[p].length) {
      return p;
    }
  }

  return "low";
};

export const mapIntegrations = crossLaunch => {
  const mapped = {};

  crossLaunch &&
    crossLaunch.forEach(integration => {
      const {id} = integration;

      mapped[id] = integration;
    });

  return mapped;
};

export const mapNotifications = (notifications = []) => {
  const now = new Date();

  if (!notifications || !Array.isArray(notifications)) {
    return [];
  }

  // Add in relative times
  const mapped = notifications
    .sort((a, b) => {
      const {timestamp: aDate} = a,
        {timestamp: bDate} = b,
        diff = new Date(aDate) - new Date(bDate);

      if (!diff === 0) {
        return 0;
      } else if (diff > 0) {
        return -1;
      }

      return 1;
    })
    .map(n => {
      n.seen = n.status !== STATUS.NEW;

      return n;
    })
    .filter(n => new Date(n.timestamp) <= now);

  return mapped;
};

const cleanTime = date => {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0, 0);
};

const getStartOfWeek = () => {
  const date = new Date();
  cleanTime(date);

  const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);

  return new Date(date.setDate(diff));
};

const getLastWeek = () => {
  const date = new Date();
  cleanTime(date);

  const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);

  return new Date(date.setDate(diff - 7));
};

const getStartOfMonth = () => {
  const date = new Date();
  cleanTime(date);
  date.setDate(1);

  date.setMonth(date.getMonth());

  return date;
};

const getLastMonth = () => {
  const date = new Date();
  cleanTime(date);
  date.setDate(1);

  date.setMonth(date.getMonth() - 1);

  return date;
};

export const mapByTimestamp = (notifications = []) => {
  const periodMapped = {
      today: [],
      yesterday: [],
      thisWeek: [],
      lastWeek: [],
      lastMonth: [],
      thisMonth: [],
      older: []
    },
    today = new Date(), // Today
    yesterday = new Date(Date.now() - 86400000), // Yesterday
    startOfWeek = getStartOfWeek(),
    lastWeek = getLastWeek(),
    startOfMonth = getStartOfMonth(),
    lastMonth = getLastMonth();

  cleanTime(today);
  cleanTime(yesterday);

  const todayTime = today.getTime(),
    yesterdayTime = yesterday.getTime(),
    startOfWeekTime = startOfWeek.getTime(),
    lastWeekTime = lastWeek.getTime(),
    startOfMonthTime = startOfMonth.getTime(),
    lastMonthTime = lastMonth.getTime();

  // Map by timestamp
  notifications.forEach(notification => {
    const {timestamp} = notification,
      date = new Date(timestamp);

    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0, 0);

    const time = date.getTime();

    // Today and Yesterday
    if (time == todayTime) {
      periodMapped.today.push(notification);
    } else if (time == yesterdayTime) {
      periodMapped.yesterday.push(notification);
    }

    // This Week
    if (time >= startOfWeekTime) {
      periodMapped.thisWeek.push(notification);
    }

    // This Month
    if (time >= startOfMonthTime) {
      periodMapped.thisMonth.push(notification);
    }

    // Last Week, Last Month, Older
    if (time >= lastWeekTime && time < startOfWeekTime) {
      periodMapped.lastWeek.push(notification);
    } else if (time >= lastMonthTime && time < startOfMonthTime) {
      periodMapped.lastMonth.push(notification);
    } else if (time < lastMonthTime) {
      periodMapped.older.push(notification);
    }

    //  ignores future dates... maybe we don't care?
  });

  return periodMapped;
};

export const mapByPriority = (notifications = []) => {
  return groupBy(notifications, "priority");
};

export const anyFilters = filters => {
  return (
    Object.values(filters).filter(f => {
      return !!f;
    }).length > 0
  );
};
